import { CloudWatchClient, GetMetricWidgetImageCommand } from '@aws-sdk/client-cloudwatch';
import { Auth } from '@aws-amplify/auth';
import config from '@iotv/config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getMetricsAry } from './getMetricsAry';
/*
 *   This function requires Cognito users to have the IAM permission: 'cloudwatch:GetMetricWidgetImage'.
 *   1. Deploy the Cognito stack with updated IAM policy from 'lsc/Identity/cognito' into a specific venture-stage environment.
 *   2. Switch the role to the same environment and then run UI locally.
 *   If a Cognito user is not granted this permission, an Error message will appear on UI, but the image field is not displayed.
 */
const debug = process.env.REACT_APP_DEBUG && false;
export const getMetricWidgetImage = async ({ resource, metricName, metricState, selectedDimensionMapList, start, end }) => {
    dayjs.extend(utc);
    const currentDate = dayjs();
    const offsetMins = currentDate.utcOffset();
    const offsetHrs = Math.abs(offsetMins / 60);
    const timezone = `+${String(offsetHrs).padStart(2, '0')}${String(offsetMins % 60).padStart(2, '0')}`;
    const metrics = getMetricsAry({ resource, metricName, selectedDimensionMapList });
    try {
        debug && console.log('metrics', metrics);
        const credentials = await Auth.currentCredentials();
        const cloudwatch = new CloudWatchClient({ region: config.aws.default_region, credentials });
        const input = {
            MetricWidget: JSON.stringify({
                metrics,
                stat: `${metricState}`,
                period: 300,
                width: 1200,
                height: 800,
                timezone,
                liveData: true,
                start: start.format(),
                end: end.isAfter(currentDate) ? 'POD' : end.format(),
            }),
            OutputFormat: 'png',
        };
        const command = new GetMetricWidgetImageCommand(input);
        debug && console.log(`fetching image with ${resource} ${metricName} ${metricState} from ${start.format()} to ${end.format()} at ${timezone}`);
        const response = await cloudwatch.send(command);
        /** CRA — this cast is to handle changes to TypeScript 5.9: https://devblogs.microsoft.com/typescript/announcing-typescript-5-9/#lib.d.ts-changes */
        return response.MetricWidgetImage;
    }
    catch (e) {
        throw e;
    }
};
